import { Box, Paper, Skeleton, Typography, alpha } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const ChatMessages = ({ messages, isLoading, messagesEndRef }) => (
  <Box
    sx={{
      flexGrow: 1,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      mb: 4,
      backgroundColor: "#f5faf6",
    }}
  >
    {messages.map((msg, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
          width: "94%",
          mx: "auto",
          mt: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: "100%",
            padding: 2,
            borderRadius: 2,
            backgroundColor:
              msg.role === "user"
                ? alpha("#2196f3", 0.1)
                : alpha("#e0e0e0", 0.7),
            backdropFilter: "blur(10px)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <Typography variant="body1" color="text.primary" component="div">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              // ...existing code...
              components={{
                h1: ({ ...props }) => <Typography variant="h4" {...props} />,
                h2: ({ ...props }) => <Typography variant="h5" {...props} />,
                h3: ({ ...props }) => <Typography variant="h6" {...props} />,
                p: ({ ...props }) => <Typography variant="body1" {...props} />,
                a: ({ ...props }) => (
                  <a
                    {...props}
                    style={{
                      color: "#2196f3",
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                ),
                code: ({ ...props }) => (
                  <code
                    {...props}
                    style={{
                      backgroundColor: alpha("#2196f3", 0.1),
                      padding: "2px 4px",
                      borderRadius: "4px",
                      fontFamily: "monospace",
                    }}
                  />
                ),
              }}
            >
              {msg.content}
            </ReactMarkdown>
          </Typography>
        </Paper>
      </Box>
    ))}

    {isLoading && (
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: "80%",
            padding: 2,
            borderRadius: 2,
            backgroundColor: alpha("#f0f0f0", 0.7),
            backdropFilter: "blur(10px)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <Skeleton variant="text" width={200} />
          <Skeleton variant="text" width={150} />
        </Paper>
      </Box>
    )}

    <div ref={messagesEndRef} />
  </Box>
);

export default ChatMessages;
